import { NavigationEnd, Router } from '@angular/router';
import { ModalService } from 'app/services/modal.service';

export abstract class ModalComponent<TResult = {}> {
    protected _isVisible: boolean;
    public get isVisible() { return this._isVisible; }

    private resolve: (value?: TResult | PromiseLike<TResult>) => void;

    constructor(protected modalService: ModalService, private router: Router) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.onNavigation();
            }
        });
    }

    public open(): Promise<TResult> {
        this.onOpen();
        this._isVisible = true;
        return new Promise<TResult>((resolve, reject) => {
            this.resolve = resolve;
        });
    }

    protected close(data: TResult) {
        this._isVisible = false;
        if (this.resolve) {
            this.resolve(data);
        }
    }

    protected onOpen() { }

    protected abstract onNavigation();
}


// WEBPACK FOOTER //
// ./src/app/components/modal/modal.component.ts